{
  "en": {
    "common": {
      "upload_company": "🏢 Upload Company Info (JSON)",
      "upload_tax": "📊 Upload Tax Rates (JSON)",
      "upload_invoice": "📄 Upload Invoice File (Excel, CSV)",
      "upload_exchange_rate": "💱 Upload Exchange Rate File (JSON)",
      "generate_invoice": "📄 Generate Invoice",
      "cancel": "❌ Cancel",
      "generating": "Generating invoices"
    },
    "invoice": {
      "title": "Invoice",
      "recipient_details": "Recipient Details",
      "asin": "ASIN",
      "name": "Name",
      "city": "City",
      "state": "State",
      "postal_code": "Postal Code",
      "country": "Country",
      "purchase_date": "Purchase Date",
      "product_name": "Product Name",
      "quantity": "Quantity",
      "price": "Price",
      "description": "Description",
      "amount": "Amount",
      "total_item_price": "Total Item Price",
      "total_shipping_cost": "Total Shipping Cost",
      "item_discounts": "Item Discounts",
      "shipping_discounts": "Shipping Discounts",
      "subtotal": "Subtotal",
      "product_tax": "Product Tax (VAT)",
      "shipping_tax": "Shipping Tax (VAT)",
      "total_tax": "Total Tax",
      "total_amount": "Total Amount",
      "end_customer": "End-Customer"
    },
    "footer": {
      "exchange_rate_info": "Prices are converted from {currency} to EUR according to the mid-rate of the Croatian National Bank (HNB)",
      "exchange_rate_date": "on {date} at the rate of 1 {currency} = {rate} EUR.",
      "issued_by": "Issued by:"
    },
    "disclaimers": {
      "US": [
        "Export to third country (USA) - VAT exempt according to Article 45 of the VAT Law of the Republic of Croatia.",
        "Sales tax in the USA is charged and paid by Amazon as an intermediary on the market."
      ],
      "AT": [
        "Small business - not VAT liable in accordance with the VAT Law of the Republic of Croatia (Article 90).",
        "Sales tax in Austria is charged and paid by Amazon as an intermediary on the market."
      ],
      "DE": [
        "Small business - not VAT liable in accordance with the VAT Law of the Republic of Croatia (Article 90).",
        "Sales tax in Germany is charged and paid by Amazon as an intermediary on the market."
      ],
      "HR": [
        "Malo poduzece - nije obveznik PDV-a u skladu sa Zakonom o PDV-u Republike Hrvatske (Clanak 90).",
        "Porez na promet u Hrvatskoj naplacuje i podmiruje Amazon kao posrednik na trzistu."
      ],
      "vine": [
        "This product was provided as part of the Amazon Vine program.",
        "The review is based on the actual product experience and is intended to help customers make informed purchase decisions."
      ]
    }
  },
  "hr": {
    "common": {
      "upload_company": "🏢 Ucitaj Podatke o Tvrtki (JSON)",
      "upload_tax": "📊 Učitaj porezne stope (JSON)",
      "upload_invoice": "📄 Ucitaj Datoteku Racuna (Excel, CSV)",
      "upload_exchange_rate": "💱 Ucitaj Datoteku Tecaja (JSON)",
      "generate_invoice": "📄 Generiraj Racun",
      "cancel": "❌ Otkazi",
      "generating": "Generiranje racuna"
    },
    "invoice": {
      "title": "Racun",
      "recipient_details": "Podaci o primatelju",
      "name": "Ime",
      "city": "Grad",
      "asin": "ASIN",
      "state": "Drzava",
      "postal_code": "Postanski broj",
      "country": "Zemlja",
      "purchase_date": "Datum kupnje",
      "product_name": "Naziv proizvoda",
      "quantity": "Kolicina",
      "price": "Cijena",
      "description": "Opis",
      "amount": "Iznos",
      "total_item_price": "Ukupna cijena proizvoda",
      "total_shipping_cost": "Ukupni troskovi dostave",
      "item_discounts": "Popusti na proizvode",
      "shipping_discounts": "Popusti na dostavu",
      "subtotal": "Meduzbir",
      "product_tax": "Porez na proizvode (PDV)",
      "shipping_tax": "Porez na dostavu (PDV)",
      "total_tax": "Ukupan porez",
      "total_amount": "Ukupan iznos",
      "end_customer": "Krajnji kupac"
    },
    "footer": {
      "exchange_rate_info": "Cijene su preracunate iz {currency} u EUR prema srednjem tecaju Hrvatske narodne banke (HNB)",
      "exchange_rate_date": "na dan {date} po tecaju 1 {currency} = {rate} EUR.",
      "issued_by": "Izdano od:"
    },
    "disclaimers": {
      "US": [
        "Izvoz u trecu zemlju (SAD) - oslobodeno PDV-a prema clanku 45. Zakona o PDV-u Republike Hrvatske.",
        "Porez na promet u SAD-u naplacuje i podmiruje Amazon kao posrednik na trzistu."
      ],
      "AT": [
        "Malo poduzece - nije obveznik PDV-a u skladu sa Zakonom o PDV-u Republike Hrvatske (Clanak 90).",
        "Porez na promet u Austriji naplacuje i podmiruje Amazon kao posrednik na trzistu."
      ],
      "DE": [
        "Malo poduzece - nije obveznik PDV-a u skladu sa Zakonom o PDV-u Republike Hrvatske (Clanak 90).",
        "Porez na promet u Njemackoj naplacuje i podmiruje Amazon kao posrednik na trzistu."
      ],
      "HR": [
        "Malo poduzece - nije obveznik PDV-a u skladu sa Zakonom o PDV-u Republike Hrvatske (Clanak 90).",
        "Porez na promet u Hrvatskoj naplacuje i podmiruje Amazon kao posrednik na trzistu."
      ],
      "vine": [
        "Ovaj proizvod je pruzen kao dio Amazon Vine programa.",
        "Recenzija se temelji na iskustvu sa stvarnim proizvodom i namjena joj je pomoci kupcima pri donosenju informiranih odluka o kupnji."
      ]
    }
  },
  "de": {
    "common": {
      "upload_company": "🏢 Unternehmensinfo hochladen (JSON)",
      "upload_tax": "📊 Steuersätze hochladen (JSON)",
      "upload_invoice": "📄 Rechnungsdatei hochladen (Excel, CSV)",
      "upload_exchange_rate": "💱 Wechselkursdatei hochladen (JSON)",
      "generate_invoice": "📄 Rechnung generieren",
      "cancel": "❌ Abbrechen",
      "generating": "Rechnungen werden generiert"
    },
    "invoice": {
      "title": "Rechnung",
      "asin": "ASIN",
      "recipient_details": "Empfaengerdetails",
      "name": "Name",
      "city": "Stadt",
      "state": "Bundesland",
      "postal_code": "Postleitzahl",
      "country": "Land",
      "purchase_date": "Kaufdatum",
      "product_name": "Produktname",
      "quantity": "Menge",
      "price": "Preis",
      "description": "Beschreibung",
      "amount": "Betrag",
      "total_item_price": "Gesamter Artikelpreis",
      "total_shipping_cost": "Gesamte Versandkosten",
      "item_discounts": "Artikelrabatte",
      "shipping_discounts": "Versandrabatte",
      "subtotal": "Zwischensumme",
      "product_tax": "Produktsteuer (USt)",
      "shipping_tax": "Versandsteuer (USt)",
      "total_tax": "Gesamtsteuer",
      "total_amount": "Gesamtbetrag",
      "end_customer": "Endkunde"
    },
    "footer": {
      "exchange_rate_info": "Preise werden von {currency} zu EUR nach dem Mittelkurs der Kroatischen Nationalbank (HNB) umgerechnet",
      "exchange_rate_date": "am {date} zum Kurs von 1 {currency} = {rate} EUR.",
      "issued_by": "Ausgestellt von:"
    },
    "disclaimers": {
      "US": [
        "Ausfuhr in ein Drittland (USA) - Umsatzsteuerbefreiung gemaess Artikel 45 des Umsatzsteuergesetzes der Republik Kroatien.",
        "Die Umsatzsteuer in den USA wird von Amazon als Marktvertreter erhoben und entrichtet."
      ],
      "AT": [
        "Kleinunternehmen - nicht umsatzsteuerpflichtig gemaess Umsatzsteuergesetz der Republik Kroatien (Artikel 90).",
        "Die Umsatzsteuer in Oesterreich wird von Amazon als Marktvertreter erhoben und entrichtet."
      ],
      "DE": [
        "Kleinunternehmen - nicht umsatzsteuerpflichtig gemaess Umsatzsteuergesetz der Republik Kroatien (Artikel 90).",
        "Die Umsatzsteuer in Deutschland wird von Amazon als Marktvertreter erhoben und entrichtet."
      ],
      "HR": [
        "Kleinunternehmen - nicht umsatzsteuerpflichtig gemaess Umsatzsteuergesetz der Republik Kroatien (Artikel 90).",
        "Die Umsatzsteuer in Kroatien wird von Amazon als Marktvertreter erhoben und entrichtet."
      ],
      "vine": [
        "Dieses Produkt wurde als Teil des Amazon Vine-Programms bereitgestellt.",
        "Die Bewertung basiert auf tatsaechlichen Produkterfahrungen und soll Kunden dabei helfen, informierte Kaufentscheidungen zu treffen."
      ]
    }
  }
}